var k = Object.defineProperty;
var C = (o, g, e) => g in o ? k(o, g, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[g] = e;
var i = (o, g, e) => C(o, typeof g != "symbol" ? g + "" : g, e);
import "@cycap/go-wasm";
import { RPC as D, RPCMessageEvent as L } from "rpc-shooter";
import { v4 as r } from "uuid";
function A() {
  return typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope;
}
function B(o) {
  return (g, e, n) => {
    if (A())
      throw new Error(
        "`startWorkerFromMain` should only be called from the main thread"
      );
    if (typeof Worker > "u")
      throw new Error(
        "Web workers not available. sqlite3 requires web workers to work."
      );
    o().then(({ default: s }) => {
      let a = new s();
      a.postMessage({ type: "init", buffers: [g, e] }), a.addEventListener("message", (M) => {
        n.postMessage(M.data);
      });
    });
  };
}
function b(o, g) {
  const e = B(g);
  return (n) => {
    n.addEventListener("message", (s) => {
      switch (s.data.type) {
        case o:
          e(s.data.argBuffer, s.data.resultBuffer, n);
          break;
      }
    });
  };
}
const U = b(
  "__absurd:spawn-idb-worker",
  () => import("./DBWorker.js")
), O = {
  ErrorInit: 10001,
  ErrorNoRecord: 10002,
  ErrorDBTimeout: 10003
};
function _(o) {
  return new Worker(
    "" + new URL("worker.js", import.meta.url).href,
    {
      name: o == null ? void 0 : o.name
    }
  );
}
let d, w;
function h() {
  typeof window > "u" || (w = new _(), U(w), d = new D({
    event: new L({
      currentEndpoint: w,
      targetEndpoint: w
    })
  }));
}
function F() {
  d && (d.destroy(), d = void 0), w && (w.terminate(), w = void 0);
}
h();
function y(o) {
  if (o.code === -32300)
    return F(), JSON.stringify({
      data: "",
      errCode: O.ErrorDBTimeout,
      errMsg: "database maybe damaged"
    });
  throw o;
}
function t(o, g, e = !0) {
  return async (...n) => {
    if ((!d || !w) && h(), !!d)
      try {
        console.info(
          `=> (invoked by go wasm) run ${g ?? o} method with args ${JSON.stringify(n)}`
        );
        const s = await d.invoke(o, ...n, { timeout: 5e6 });
        return console.info(
          `=> (invoked by go wasm) run ${g ?? o} method with response `,
          JSON.stringify(s)
        ), e ? JSON.stringify(s) : s;
      } catch (s) {
        y(s);
      }
  };
}
const p = t("fileMapSet"), R = t("fileMapClear");
function N(o) {
  d && (window.wasmOpen = t("wasmOpen"), window.wasmClose = t("wasmClose"), window.wasmRead = t("wasmRead", "wasmRead", !1), window.getUpload = t("getUpload"), window.insertUpload = t("insertUpload"), window.updateUpload = t("updateUpload"), window.deleteUpload = t("deleteUpload"), window.initDB = t("initDB").bind(null, o), window.close = t("close"), window.getMessage = t("getMessage"), window.getMultipleMessage = t("getMultipleMessage"), window.getSendingMessageList = t("getSendingMessageList"), window.getNormalMsgSeq = t("getNormalMsgSeq"), window.updateMessageTimeAndStatus = t(
    "updateMessageTimeAndStatus"
  ), window.updateMessage = t("updateMessage"), window.updateMessageBySeq = t("updateMessageBySeq"), window.updateColumnsMessage = t("updateColumnsMessage"), window.insertMessage = t("insertMessage"), window.batchInsertMessageList = t(
    "batchInsertMessageList"
  ), window.getMessageList = t("getMessageList"), window.getMessageListNoTime = t("getMessageListNoTime"), window.messageIfExists = t("messageIfExists"), window.messageIfExistsBySeq = t("messageIfExistsBySeq"), window.getAbnormalMsgSeq = t("getAbnormalMsgSeq"), window.getAbnormalMsgSeqList = t("getAbnormalMsgSeqList"), window.batchInsertExceptionMsg = t(
    "batchInsertExceptionMsg"
  ), window.searchMessageByKeyword = t(
    "searchMessageByKeyword"
  ), window.searchMessageByContentType = t(
    "searchMessageByContentType"
  ), window.searchMessageByContentTypeAndKeyword = t(
    "searchMessageByContentTypeAndKeyword"
  ), window.updateMsgSenderNickname = t(
    "updateMsgSenderNickname"
  ), window.updateMsgSenderFaceURL = t(
    "updateMsgSenderFaceURL"
  ), window.updateMsgSenderFaceURLAndSenderNickname = t(
    "updateMsgSenderFaceURLAndSenderNickname"
  ), window.getMsgSeqByClientMsgID = t(
    "getMsgSeqByClientMsgID"
  ), window.getMsgSeqListByGroupID = t(
    "getMsgSeqListByGroupID"
  ), window.getMsgSeqListByPeerUserID = t(
    "getMsgSeqListByPeerUserID"
  ), window.getMsgSeqListBySelfUserID = t(
    "getMsgSeqListBySelfUserID"
  ), window.deleteAllMessage = t("deleteAllMessage"), window.getAllUnDeleteMessageSeqList = t(
    "getAllUnDeleteMessageSeqList"
  ), window.updateSingleMessageHasRead = t(
    "updateSingleMessageHasRead"
  ), window.updateGroupMessageHasRead = t(
    "updateGroupMessageHasRead"
  ), window.updateMessageStatusBySourceID = t(
    "updateMessageStatusBySourceID"
  ), window.getAlreadyExistSeqList = t(
    "getAlreadyExistSeqList"
  ), window.getMessageBySeq = t("getMessageBySeq"), window.getMessagesByClientMsgIDs = t(
    "getMessagesByClientMsgIDs"
  ), window.getMessagesBySeqs = t("getMessagesBySeqs"), window.getConversationNormalMsgSeq = t(
    "getConversationNormalMsgSeq"
  ), window.getConversationPeerNormalMsgSeq = t(
    "getConversationPeerNormalMsgSeq"
  ), window.deleteConversationAllMessages = t(
    "deleteConversationAllMessages"
  ), window.markDeleteConversationAllMessages = t(
    "markDeleteConversationAllMessages"
  ), window.getUnreadMessage = t("getUnreadMessage"), window.markConversationMsgAsReadBySeqs = t(
    "markConversationMsgAsReadBySeqs"
  ), window.markConversationMsgAsReadDB = t(
    "markConversationMsgAsRead"
  ), window.deleteConversationMsgs = t(
    "deleteConversationMsgs"
  ), window.markConversationAllMessageAsRead = t(
    "markConversationAllMessageAsRead"
  ), window.searchAllMessageByContentType = t(
    "searchAllMessageByContentType"
  ), window.insertSendingMessage = t("insertSendingMessage"), window.deleteSendingMessage = t("deleteSendingMessage"), window.getAllSendingMessages = t("getAllSendingMessages"), window.getAllConversationListDB = t(
    "getAllConversationList"
  ), window.getAllConversationListToSync = t(
    "getAllConversationListToSync"
  ), window.getHiddenConversationList = t(
    "getHiddenConversationList"
  ), window.getConversation = t("getConversation"), window.getMultipleConversationDB = t(
    "getMultipleConversation"
  ), window.updateColumnsConversation = t(
    "updateColumnsConversation"
  ), window.updateConversation = t(
    "updateColumnsConversation",
    "updateConversation"
  ), window.updateConversationForSync = t(
    "updateColumnsConversation",
    "updateConversationForSync"
  ), window.decrConversationUnreadCount = t(
    "decrConversationUnreadCount"
  ), window.batchInsertConversationList = t(
    "batchInsertConversationList"
  ), window.insertConversation = t("insertConversation"), window.getTotalUnreadMsgCountDB = t(
    "getTotalUnreadMsgCount"
  ), window.getConversationByUserID = t(
    "getConversationByUserID"
  ), window.getConversationListSplitDB = t(
    "getConversationListSplit"
  ), window.deleteConversation = t("deleteConversation"), window.batchUpdateConversationList = t(
    "batchUpdateConversationList"
  ), window.conversationIfExists = t("conversationIfExists"), window.resetConversation = t("resetConversation"), window.resetAllConversation = t("resetAllConversation"), window.clearConversation = t("clearConversation"), window.clearAllConversation = t("clearAllConversation"), window.setConversationDraftDB = t("setConversationDraft"), window.removeConversationDraft = t(
    "removeConversationDraft"
  ), window.unPinConversation = t("unPinConversation"), window.incrConversationUnreadCount = t(
    "incrConversationUnreadCount"
  ), window.setMultipleConversationRecvMsgOpt = t(
    "setMultipleConversationRecvMsgOpt"
  ), window.getAllSingleConversationIDList = t(
    "getAllSingleConversationIDList"
  ), window.getAllConversationIDList = t(
    "getAllConversationIDList"
  ), window.getAllConversations = t("getAllConversations"), window.getLoginUser = t("getLoginUser"), window.insertLoginUser = t("insertLoginUser"), window.updateLoginUser = t("updateLoginUser"), window.getStrangerInfo = t("getStrangerInfo"), window.setStrangerInfo = t("setStrangerInfo"), window.getJoinedSuperGroupList = t(
    "getJoinedSuperGroupList"
  ), window.getJoinedSuperGroupIDList = t(
    "getJoinedSuperGroupIDList"
  ), window.getSuperGroupInfoByGroupID = t(
    "getSuperGroupInfoByGroupID"
  ), window.deleteSuperGroup = t("deleteSuperGroup"), window.insertSuperGroup = t("insertSuperGroup"), window.updateSuperGroup = t("updateSuperGroup"), window.deleteConversationUnreadMessageList = t(
    "deleteConversationUnreadMessageList"
  ), window.batchInsertConversationUnreadMessageList = t(
    "batchInsertConversationUnreadMessageList"
  ), window.superGroupGetMessage = t("superGroupGetMessage"), window.superGroupGetMultipleMessage = t(
    "superGroupGetMultipleMessage"
  ), window.superGroupGetNormalMinSeq = t(
    "superGroupGetNormalMinSeq"
  ), window.getSuperGroupNormalMsgSeq = t(
    "getSuperGroupNormalMsgSeq"
  ), window.superGroupUpdateMessageTimeAndStatus = t(
    "superGroupUpdateMessageTimeAndStatus"
  ), window.superGroupUpdateMessage = t(
    "superGroupUpdateMessage"
  ), window.superGroupInsertMessage = t(
    "superGroupInsertMessage"
  ), window.superGroupBatchInsertMessageList = t(
    "superGroupBatchInsertMessageList"
  ), window.superGroupGetMessageListNoTime = t(
    "superGroupGetMessageListNoTime"
  ), window.superGroupGetMessageList = t(
    "superGroupGetMessageList"
  ), window.superGroupUpdateColumnsMessage = t(
    "superGroupUpdateColumnsMessage"
  ), window.superGroupDeleteAllMessage = t(
    "superGroupDeleteAllMessage"
  ), window.superGroupSearchMessageByKeyword = t(
    "superGroupSearchMessageByKeyword"
  ), window.superGroupSearchMessageByContentType = t(
    "superGroupSearchMessageByContentType"
  ), window.superGroupSearchMessageByContentTypeAndKeyword = t(
    "superGroupSearchMessageByContentTypeAndKeyword"
  ), window.superGroupUpdateMessageStatusBySourceID = t(
    "superGroupUpdateMessageStatusBySourceID"
  ), window.superGroupGetSendingMessageList = t(
    "superGroupGetSendingMessageList"
  ), window.superGroupUpdateGroupMessageHasRead = t(
    "superGroupUpdateGroupMessageHasRead"
  ), window.superGroupGetMsgSeqByClientMsgID = t(
    "superGroupGetMsgSeqByClientMsgID"
  ), window.superGroupUpdateMsgSenderFaceURLAndSenderNickname = t("superGroupUpdateMsgSenderFaceURLAndSenderNickname"), window.superGroupSearchAllMessageByContentType = t(
    "superGroupSearchAllMessageByContentType"
  ), window.exec = t("exec"), window.getRowsModified = t("getRowsModified"), window.exportDB = async () => {
    if ((!d || !w) && h(), !!d)
      try {
        console.info("=> (invoked by go wasm) run exportDB method ");
        const g = await d.invoke("exportDB", void 0, { timeout: 5e3 });
        return console.info(
          "=> (invoked by go wasm) run exportDB method with response ",
          JSON.stringify(g)
        ), g;
      } catch (g) {
        y(g);
      }
  }, window.getBlackListDB = t("getBlackList"), window.getBlackListUserID = t("getBlackListUserID"), window.getBlackInfoByBlockUserID = t(
    "getBlackInfoByBlockUserID"
  ), window.getBlackInfoList = t("getBlackInfoList"), window.insertBlack = t("insertBlack"), window.deleteBlack = t("deleteBlack"), window.updateBlack = t("updateBlack"), window.insertFriendRequest = t("insertFriendRequest"), window.deleteFriendRequestBothUserID = t(
    "deleteFriendRequestBothUserID"
  ), window.updateFriendRequest = t("updateFriendRequest"), window.getRecvFriendApplication = t(
    "getRecvFriendApplication"
  ), window.getSendFriendApplication = t(
    "getSendFriendApplication"
  ), window.getFriendApplicationByBothID = t(
    "getFriendApplicationByBothID"
  ), window.getBothFriendReq = t("getBothFriendReq"), window.insertFriend = t("insertFriend"), window.deleteFriendDB = t("deleteFriend"), window.updateFriend = t("updateFriend"), window.getAllFriendList = t("getAllFriendList"), window.searchFriendList = t("searchFriendList"), window.getFriendInfoByFriendUserID = t(
    "getFriendInfoByFriendUserID"
  ), window.getFriendInfoList = t("getFriendInfoList"), window.getPageFriendList = t("getPageFriendList"), window.insertGroup = t("insertGroup"), window.deleteGroup = t("deleteGroup"), window.updateGroup = t("updateGroup"), window.getJoinedGrpListDB = t("getJoinedGrpList"), window.getGroupInfoByGroupID = t("getGroupInfoByGroupID"), window.getAllGroupInfoByGroupIDOrGroupName = t(
    "getAllGroupInfoByGroupIDOrGroupName"
  ), window.subtractMemberCount = t("subtractMemberCount"), window.addMemberCount = t("addMemberCount"), window.getJoinedWorkingGroupIDList = t(
    "getJoinedWorkingGroupIDList"
  ), window.getJoinedWorkingGroupList = t(
    "getJoinedWorkingGroupList"
  ), window.getGroupMemberAllGroupIDs = t(
    "getGroupMemberAllGroupIDs"
  ), window.getUserJoinedGroupIDs = t("getUserJoinedGroupIDs"), window.getGroups = t("getGroups"), window.insertGroupRequest = t("insertGroupRequest"), window.deleteGroupRequest = t("deleteGroupRequest"), window.updateGroupRequest = t("updateGroupRequest"), window.getSendGroupApplication = t(
    "getSendGroupApplication"
  ), window.insertAdminGroupRequest = t(
    "insertAdminGroupRequest"
  ), window.deleteAdminGroupRequest = t(
    "deleteAdminGroupRequest"
  ), window.updateAdminGroupRequest = t(
    "updateAdminGroupRequest"
  ), window.getAdminGroupApplication = t(
    "getAdminGroupApplication"
  ), window.getGroupMemberInfoByGroupIDUserID = t(
    "getGroupMemberInfoByGroupIDUserID"
  ), window.getAllGroupMemberList = t("getAllGroupMemberList"), window.getAllGroupMemberUserIDList = t(
    "getAllGroupMemberUserIDList"
  ), window.getGroupMemberCount = t("getGroupMemberCount"), window.getGroupSomeMemberInfo = t(
    "getGroupSomeMemberInfo"
  ), window.getGroupAdminID = t("getGroupAdminID"), window.getGrpMemberListByGroupID = t(
    "getGrpMemberListByGroupID"
  ), window.getGrpMemberListSplit = t(
    "getGrpMemberListSplit"
  ), window.getGrpMemberOwnerAndAdminDB = t(
    "getGrpMemberOwnerAndAdmin"
  ), window.getGroupMemberOwner = t("getGroupMemberOwner"), window.getGrpMemberListSplitByJoinTimeFilter = t(
    "getGrpMemberListSplitByJoinTimeFilter"
  ), window.getGroupOwnerAndAdminByGroupID = t(
    "getGroupOwnerAndAdminByGroupID"
  ), window.getGroupMemberUIDListByGroupID = t(
    "getGroupMemberUIDListByGroupID"
  ), window.insertGroupMember = t("insertGroupMember"), window.batchInsertGroupMember = t(
    "batchInsertGroupMember"
  ), window.deleteGroupMember = t("deleteGroupMember"), window.deleteGroupAllMembers = t("deleteGroupAllMembers"), window.updateGroupMember = t("updateGroupMember"), window.updateGroupMemberField = t(
    "updateGroupMemberField"
  ), window.searchGrpMembersDB = t(
    "searchGrpMembers",
    "searchGrpMembersDB"
  ), window.batchInsertTempCacheMessageList = t(
    "batchInsertTempCacheMessageList"
  ), window.InsertTempCacheMessage = t(
    "InsertTempCacheMessage"
  ), window.getNotificationAllSeqs = t(
    "getNotificationAllSeqs"
  ), window.setNotificationSeq = t("setNotificationSeq"));
}
const J = d == null ? void 0 : d.connect(5e3);
class q {
  constructor() {
    i(this, "events");
    this.events = {};
  }
  emit(g, e) {
    return this.events[g] && this.events[g].forEach((n) => n(e)), this;
  }
  on(g, e) {
    return this.events[g] ? this.events[g].push(e) : this.events[g] = [e], this;
  }
  off(g, e) {
    if (g && typeof e == "function" && this.events[g]) {
      const n = this.events[g];
      if (!n || n.length === 0)
        return this;
      const s = n.findIndex((a) => a === e);
      s !== -1 && n.splice(s, 1);
    }
    return this;
  }
}
async function T(o) {
  return new Promise((g) => {
    const e = setTimeout(() => {
      clearTimeout(e), g(null);
    }, o);
  });
}
function f(o, g) {
  return `font-size:14px; background:${o ?? "#ffffff"}; color:${g ?? "#000000"}; border-radius:4px; padding-inline:4px;`;
}
let c, m;
async function x(o) {
  if (typeof window > "u")
    return Promise.resolve(null);
  if (c = new Go(), "instantiateStreaming" in WebAssembly) {
    const g = await WebAssembly.instantiateStreaming(
      fetch(o),
      c.importObject
    );
    c.run(g.instance);
  } else {
    const g = await fetch(o).then((n) => n.arrayBuffer()), e = await WebAssembly.instantiate(g, c.importObject);
    m = c.run(e.instance);
  }
  return await T(100), c;
}
function G() {
  return c;
}
function E() {
  return m;
}
var I = /* @__PURE__ */ ((o) => (o[o.iOS = 1] = "iOS", o[o.Android = 2] = "Android", o[o.Windows = 3] = "Windows", o[o.MacOSX = 4] = "MacOSX", o[o.Web = 5] = "Web", o[o.Linux = 7] = "Linux", o[o.AndroidPad = 8] = "AndroidPad", o[o.iPad = 9] = "iPad", o))(I || {});
class P extends q {
  constructor(e) {
    console.log("get SDK: ", JSON.stringify(e));
    super();
    i(this, "wasmInitializedPromise");
    i(this, "goExitPromise");
    i(this, "goExisted", !1);
    i(this, "tryParse", !0);
    i(this, "isLogStandardOutput", !0);
    i(this, "sdkVersion", "2.5.3");
    i(this, "login", async (e, n = r()) => {
      this._logWrap(
        `SDK => (invoked by js) run login with args ${JSON.stringify({
          params: e,
          operationID: n
        })}`
      ), await J, await this.wasmInitializedPromise, window.commonEventFunc((M) => {
        try {
          console.info(
            `%cSDK =>%c received event %c${M}%c `,
            f("#282828", "#ffffff"),
            "",
            "color: #4f2398;",
            ""
          );
          const l = JSON.parse(M);
          if (this.tryParse)
            try {
              l.data = JSON.parse(l.data);
            } catch {
            }
          this.emit(l.event, l);
        } catch (l) {
          console.error(l);
        }
      });
      let s = e.sdkServer;
      /^https?:\/\//.test(s) || (s = "http://" + s);
      const a = {
        platformID: I.Web,
        // apiAddr: params.apiAddr,
        // wsAddr: params.wsAddr,
        sdkServer: s,
        dataDir: "./",
        logLevel: e.logLevel || 5,
        isLogStandardOutput: e.isLogStandardOutput ?? !0,
        logFilePath: "./",
        isExternalExtensions: e.isExternalExtensions || !1
      };
      return this.tryParse = e.tryParse ?? !0, this.isLogStandardOutput = a.isLogStandardOutput, window.unInitSDK(n), window.initSDK(n, JSON.stringify(a)), await window.login(n, e.userID, e.token ?? "", e.appId ?? "", e.appSecret ?? "");
    });
    i(this, "logout", (e = r()) => (R(), this._invoker("logout", window.logout, [e])));
    i(this, "getAllConversationList", (e = r()) => this._invoker(
      "getAllConversationList",
      window.getAllConversationList,
      [e]
    ));
    i(this, "getOneConversation", (e, n = r()) => this._invoker(
      "getOneConversation",
      window.getOneConversation,
      [n, e.sessionType, e.sourceID]
    ));
    i(this, "getAdvancedHistoryMsgList", (e, n = r()) => this._invoker(
      "getAdvancedHistoryMsgList",
      window.getAdvancedHistoryMsgList,
      [n, JSON.stringify(e)]
    ));
    i(this, "getAdvancedHistoryMsgListReverse", (e, n = r()) => this._invoker(
      "getAdvancedHistoryMsgListReverse",
      window.getAdvancedHistoryMsgListReverse,
      [n, JSON.stringify(e)]
    ));
    i(this, "getSpecifiedGrpsInfo", (e, n = r()) => this._invoker(
      "getSpecifiedGrpsInfo",
      window.getSpecifiedGrpsInfo,
      [n, JSON.stringify(e)]
    ));
    i(this, "deleteConversationAndDeleteAllMsg", (e, n = r()) => this._invoker(
      "deleteConversationAndDeleteAllMsg",
      window.deleteConversationAndDeleteAllMsg,
      [n, e]
    ));
    i(this, "markConversationMsgAsRead", (e, n = r()) => this._invoker(
      "markConversationMsgAsRead",
      window.markConversationMsgAsRead,
      [n, e]
    ));
    i(this, "markMsgsAsReadByMsgID", (e, n = r()) => this._invoker(
      "markMsgsAsReadByMsgID",
      window.markMsgsAsReadByMsgID,
      [
        n,
        e.conversationID,
        JSON.stringify(e.clientMsgIDList)
      ]
    ));
    /* sendGroupMessageReadReceipt = <T>(
      params: SendGroupReadReceiptParams,
      operationID = uuidv4()
    ) => {
      return this._invoker<T>(
        'sendGroupMessageReadReceipt',
        window.sendGroupMessageReadReceipt,
        [
          operationID,
          params.conversationID,
          JSON.stringify(params.clientMsgIDList),
        ]
      );
    };
    getGroupMessageReaderList = <T>(
      params: GetGroupMessageReaderParams,
      operationID = uuidv4()
    ) => {
      return this._invoker<T>(
        'getGroupMessageReaderList',
        window.getGroupMessageReaderList,
        [
          operationID,
          params.conversationID,
          params.clientMsgID,
          params.filter,
          params.offset,
          params.count,
        ]
      );
    }; */
    i(this, "getGrpMemberList", (e, n = r()) => this._invoker(
      "getGrpMemberList",
      window.getGrpMemberList,
      [n, e.groupID, e.filter, e.offset, e.count]
    ));
    i(this, "createTextMsg", (e, n = r()) => this._invoker(
      "createTextMsg",
      window.createTextMsg,
      [n, e],
      (s) => s[0]
    ));
    i(this, "createImageMsg", (e, n = r()) => this._invoker(
      "createImageMsg",
      window.createImageMsgByURL,
      [
        n,
        e.sourcePath,
        JSON.stringify(e.sourcePicture),
        JSON.stringify(e.bigPicture),
        JSON.stringify(e.snapshotPicture)
      ],
      (s) => s[0]
    ));
    i(this, "createImageMsgByFile", (e, n = r()) => (e.sourcePicture.uuid = `${e.sourcePicture.uuid}/${e.file.name}`, p(e.sourcePicture.uuid, e.file), this._invoker(
      "createImageMsgByFile",
      window.createImageMsgByURL,
      [
        n,
        e.sourcePath,
        JSON.stringify(e.sourcePicture),
        JSON.stringify(e.bigPicture),
        JSON.stringify(e.snapshotPicture)
      ],
      (s) => s[0]
    )));
    i(this, "createCustomMsg", (e, n = r()) => this._invoker(
      "createCustomMsg",
      window.createCustomMsg,
      [n, e.data, e.extension, e.description],
      (s) => s[0]
    ));
    i(this, "createQuoteMsg", (e, n = r()) => {
      const s = JSON.stringify(e.message);
      return this._invoker(
        "createQuoteMsg",
        window.createQuoteMsg,
        [n, e.text, s],
        (a) => a[0]
      );
    });
    i(this, "createAdvancedQuoteMsg", (e, n = r()) => this._invoker(
      "createAdvancedQuoteMsg",
      window.createAdvancedQuoteMsg,
      [
        n,
        e.text,
        JSON.stringify(e.message),
        JSON.stringify(e.messageEntityList)
      ],
      (s) => s[0]
    ));
    i(this, "createAdvancedTextMsg", (e, n = r()) => this._invoker(
      "createAdvancedTextMsg",
      window.createAdvancedTextMsg,
      [n, e.text, JSON.stringify(e.messageEntityList)],
      (s) => s[0]
    ));
    i(this, "sendMsg", (e, n = r()) => {
      const s = e.offlinePushInfo ?? {
        title: "你有一条新消息",
        desc: "",
        ex: "",
        iOSPushSound: "+1",
        iOSBadgeCount: !0
      };
      return this._invoker("sendMsg", window.sendMsg, [
        n,
        JSON.stringify(e.message),
        e.recvID,
        e.groupID,
        JSON.stringify(s)
      ]);
    });
    i(this, "sendMsgNotOss", (e, n = r()) => {
      const s = e.offlinePushInfo ?? {
        title: "你有一条新消息",
        desc: "",
        ex: "",
        iOSPushSound: "+1",
        iOSBadgeCount: !0
      };
      return this._invoker(
        "sendMsgNotOss",
        window.sendMsgNotOss,
        [
          n,
          JSON.stringify(e.message),
          e.recvID,
          e.groupID,
          JSON.stringify(s)
        ]
      );
    });
    i(this, "sendMsgByBuffer", (e, n = r()) => {
      const s = e.offlinePushInfo ?? {
        title: "你有一条新消息",
        desc: "",
        ex: "",
        iOSPushSound: "+1",
        iOSBadgeCount: !0
      };
      return this._invoker("sendMsgByBuffer", window.sendMsgByBuffer, [
        n,
        JSON.stringify(e.message),
        e.recvID,
        e.groupID,
        JSON.stringify(s),
        e.fileArrayBuffer,
        e.snpFileArrayBuffer
      ]);
    });
    i(this, "setMsgLocalEx", (e, n = r()) => this._invoker("setMsgLocalEx", window.setMsgLocalEx, [
      n,
      e.conversationID,
      e.clientMsgID,
      e.localEx
    ]));
    /*   getHistoryMessageListReverse = <T>(
        params: GetHistoryMsgParams,
        operationID = uuidv4()
      ) => {
        return this._invoker<T>(
          'getHistoryMessageListReverse',
          window.getHistoryMessageListReverse,
          [operationID, JSON.stringify(params)]
        );
      }; */
    i(this, "revokeMsg", (e, n = r()) => this._invoker("revokeMsg", window.revokeMsg, [
      n,
      e.conversationID,
      e.clientMsgID
    ]));
    i(this, "setConversationPrivateChat", (e, n = r()) => this._invoker(
      "setConversationPrivateChat",
      window.setConversationPrivateChat,
      [n, e.conversationID, e.isPrivate]
    ));
    i(this, "setConversationBurnDuration", (e, n = r()) => this._invoker(
      "setConversationBurnDuration",
      window.setConversationBurnDuration,
      [n, e.conversationID, e.burnDuration]
    ));
    i(this, "getLoginStatus", (e = r()) => this._invoker(
      "getLoginStatus",
      window.getLoginStatus,
      [e],
      (n) => n[0]
    ));
    i(this, "setAppBackgroundStatus", (e, n = r()) => this._invoker(
      "setAppBackgroundStatus",
      window.setAppBackgroundStatus,
      [n, e]
    ));
    i(this, "networkStatusChanged", (e = r()) => this._invoker(
      "networkStatusChanged ",
      window.networkStatusChanged,
      [e]
    ));
    i(this, "getLoginUserID", () => this._invoker("getLoginUserID", window.getLoginUserID, [
      // operationID,
    ]).then((e) => (e.data = e.data[0], e)));
    i(this, "getSelfUserInfo", (e = r()) => this._invoker(
      "getSelfUserInfo",
      window.getSelfUserInfo,
      [e]
    ));
    i(this, "getUsersInfo", (e, n = r()) => this._invoker("getUsersInfo", window.getUsersInfo, [
      n,
      JSON.stringify(e)
    ]));
    i(this, "getUsersInfoWithCache", (e, n = r()) => this._invoker(
      "getUsersInfoWithCache",
      window.getUsersInfoWithCache,
      [n, JSON.stringify(e.userIDList), e.groupID]
    ));
    i(this, "setSelfInfo", (e, n = r()) => this._invoker("setSelfInfo", window.setSelfInfo, [
      n,
      JSON.stringify(e)
    ]));
    i(this, "createTextAtMsg", (e, n = r()) => this._invoker(
      "createTextAtMsg",
      window.createTextAtMsg,
      [
        n,
        e.text,
        JSON.stringify(e.atUserIDList),
        JSON.stringify(e.atUsersInfo),
        JSON.stringify(e.message) ?? ""
      ],
      (s) => s[0]
    ));
    i(this, "createSoundMsg", (e, n = r()) => this._invoker(
      "createSoundMsg",
      window.createSoundMsgByURL,
      [n, JSON.stringify(e)],
      (s) => s[0]
    ));
    i(this, "createSoundMsgByFile", (e, n = r()) => (e.uuid = `${e.uuid}/${e.file.name}`, p(e.uuid, e.file), this._invoker(
      "createSoundMsgByFile",
      window.createSoundMsgByURL,
      [n, JSON.stringify(e)],
      (s) => s[0]
    )));
    i(this, "createVideoMsg", (e, n = r()) => this._invoker(
      "createVideoMsg",
      window.createVideoMsgByURL,
      [n, JSON.stringify(e)],
      (s) => s[0]
    ));
    i(this, "createVideoMsgByFile", (e, n = r()) => (e.videoUUID = `${e.videoUUID}/${e.videoFile.name}`, e.snapshotUUID = `${e.snapshotUUID}/${e.snapshotFile.name}`, p(e.videoUUID, e.videoFile), p(e.snapshotUUID, e.snapshotFile), this._invoker(
      "createVideoMsgByFile",
      window.createVideoMsgByURL,
      [n, JSON.stringify(e)],
      (s) => s[0]
    )));
    i(this, "createFileMsg", (e, n = r()) => this._invoker(
      "createFileMsg",
      window.createFileMsgByURL,
      [n, JSON.stringify(e)],
      (s) => s[0]
    ));
    i(this, "createFileMsgByFile", (e, n = r()) => (e.uuid = `${e.uuid}/${e.file.name}`, p(e.uuid, e.file), this._invoker(
      "createFileMsgByFile",
      window.createFileMsgByURL,
      [n, JSON.stringify(e)],
      (s) => s[0]
    )));
    /*  createFileMsgFromFullPath = <T>(
        data: FileMsgFullParams,
        operationID = uuidv4()
      ) => {
        return this._invoker<T>(
          'createFileMsgFromFullPath',
          window.createFileMsgFromFullPath,
          [operationID, data.fileFullPath, data.fileName],
          data => {
            // compitable with old version sdk
            return data[0];
          }
        );
      };
    
      createImageMsgFromFullPath = <T>(
        data: string,
        operationID = uuidv4()
      ) => {
        return this._invoker<T>(
          'createImageMsgFromFullPath ',
          window.createImageMsgFromFullPath,
          [operationID, data],
          data => {
            // compitable with old version sdk
            return data[0];
          }
        );
      };
    
      createSoundMsgFromFullPath = <T>(
        data: SouondMsgFullParams,
        operationID = uuidv4()
      ) => {
        return this._invoker<T>(
          'createSoundMsgFromFullPath ',
          window.createSoundMsgFromFullPath,
          [operationID, data.soundPath, data.duration],
          data => {
            // compitable with old version sdk
            return data[0];
          }
        );
      };
    
      createVideoMsgFromFullPath = <T>(
        data: VideoMsgFullParams,
        operationID = uuidv4()
      ) => {
        return this._invoker<T>(
          'createVideoMsgFromFullPath ',
          window.createVideoMsgFromFullPath,
          [
            operationID,
            data.videoFullPath,
            data.videoType,
            data.duration,
            data.snapshotFullPath,
          ],
          data => {
            // compitable with old version sdk
            return data[0];
          }
        );
      }; */
    i(this, "createMergerMsg", (e, n = r()) => this._invoker(
      "createMergerMsg ",
      window.createMergerMsg,
      [
        n,
        JSON.stringify(e.messageList),
        e.title,
        JSON.stringify(e.summaryList)
      ],
      (s) => s[0]
    ));
    i(this, "createForwardMsg", (e, n = r()) => this._invoker(
      "createForwardMsg ",
      window.createForwardMsg,
      [n, JSON.stringify(e)],
      (s) => s[0]
    ));
    i(this, "createFaceMsg", (e, n = r()) => this._invoker(
      "createFaceMsg ",
      window.createFaceMsg,
      [n, e.index, e.data],
      (s) => s[0]
    ));
    i(this, "createLocationMsg", (e, n = r()) => this._invoker(
      "createLocationMsg ",
      window.createLocationMsg,
      [n, e.description, e.longitude, e.latitude],
      (s) => s[0]
    ));
    i(this, "createCardMsg", (e, n = r()) => this._invoker(
      "createCardMsg ",
      window.createCardMsg,
      [n, JSON.stringify(e)],
      (s) => s[0]
    ));
    i(this, "deleteMsgFromLocalStorage", (e, n = r()) => this._invoker(
      "deleteMsgFromLocalStorage ",
      window.deleteMsgFromLocalStorage,
      [n, e.conversationID, e.clientMsgID]
    ));
    i(this, "deleteMsg", (e, n = r()) => this._invoker("deleteMsg ", window.deleteMsg, [
      n,
      e.conversationID,
      e.clientMsgID
    ]));
    i(this, "deleteAllConversationFromLocal", (e = r()) => this._invoker(
      "deleteAllConversationFromLocal ",
      window.deleteAllConversationFromLocal,
      [e]
    ));
    i(this, "deleteAllMsgFromLocal", (e = r()) => this._invoker(
      "deleteAllMsgFromLocal ",
      window.deleteAllMsgFromLocal,
      [e]
    ));
    i(this, "deleteAllMsgFromLocalAndSvr", (e = r()) => this._invoker(
      "deleteAllMsgFromLocalAndSvr ",
      window.deleteAllMsgFromLocalAndSvr,
      [e]
    ));
    i(this, "insertSingleMsgToLocalStorage", (e, n = r()) => this._invoker(
      "insertSingleMsgToLocalStorage ",
      window.insertSingleMsgToLocalStorage,
      [n, JSON.stringify(e.message), e.recvID, e.sendID]
    ));
    i(this, "insertGrpMsgToLocalStorage", (e, n = r()) => this._invoker(
      "insertGrpMsgToLocalStorage ",
      window.insertGrpMsgToLocalStorage,
      [n, JSON.stringify(e.message), e.groupID, e.sendID]
    ));
    i(this, "typingStatusUpdate", (e, n = r()) => this._invoker("typingStatusUpdate ", window.typingStatusUpdate, [
      n,
      e.recvID,
      e.msgTip
    ]));
    i(this, "clearConversationAndDeleteAllMsg", (e, n = r()) => this._invoker(
      "clearConversationAndDeleteAllMsg ",
      window.clearConversationAndDeleteAllMsg,
      [n, e]
    ));
    i(this, "hideConversation", (e, n = r()) => this._invoker("hideConversation ", window.hideConversation, [
      n,
      e
    ]));
    i(this, "getConversationListSplit", (e, n = r()) => this._invoker(
      "getConversationListSplit ",
      window.getConversationListSplit,
      [n, e.offset, e.count]
    ));
    i(this, "getConversationIDBySessionType", (e, n = r()) => this._invoker(
      "getConversationIDBySessionType ",
      window.getConversationIDBySessionType,
      [n, e.sourceID, e.sessionType]
    ));
    i(this, "getMultipleConversation", (e, n = r()) => this._invoker(
      "getMultipleConversation ",
      window.getMultipleConversation,
      [n, JSON.stringify(e)]
    ));
    i(this, "deleteConversation", (e, n = r()) => this._invoker("deleteConversation ", window.deleteConversation, [
      n,
      e
    ]));
    i(this, "setConversationDraft", (e, n = r()) => this._invoker(
      "setConversationDraft ",
      window.setConversationDraft,
      [n, e.conversationID, e.draftText]
    ));
    i(this, "pinConversation", (e, n = r()) => this._invoker("pinConversation ", window.pinConversation, [
      n,
      e.conversationID,
      e.isPinned
    ]));
    i(this, "getTotalUnreadMsgCount", (e = r()) => this._invoker(
      "getTotalUnreadMsgCount ",
      window.getTotalUnreadMsgCount,
      [e]
    ));
    /*   getConversationRecvMsgOpt = (data: string[], operationID = uuidv4()) => {
        return this._invoker<ConversationItem[]>(
          'getConversationRecvMsgOpt ',
          window.getConversationRecvMsgOpt,
          [operationID, JSON.stringify(data)]
        );
      }; */
    i(this, "setConversationRecvMsgOpt", (e, n = r()) => this._invoker(
      "setConversationRecvMsgOpt ",
      window.setConversationRecvMsgOpt,
      [n, e.conversationID, e.opt]
    ));
    i(this, "searchLocalMsgs", (e, n = r()) => this._invoker(
      "searchLocalMsgs ",
      window.searchLocalMsgs,
      [n, JSON.stringify(e)]
    ));
    i(this, "addFriend", (e, n = r()) => this._invoker("addFriend ", window.addFriend, [
      n,
      JSON.stringify(e)
    ]));
    i(this, "searchFriends", (e, n = r()) => this._invoker(
      "searchFriends ",
      window.searchFriends,
      [n, JSON.stringify(e)]
    ));
    i(this, "getSpecifiedFriendsInfo", (e, n = r()) => this._invoker(
      "getSpecifiedFriendsInfo ",
      window.getSpecifiedFriendsInfo,
      [n, JSON.stringify(e)]
    ));
    i(this, "getFriendReqListAsRecipient", (e = r()) => this._invoker(
      "getFriendReqListAsRecipient ",
      window.getFriendReqListAsRecipient,
      [e]
    ));
    i(this, "getFriendReqListAsApplicant", (e = r()) => this._invoker(
      "getFriendReqListAsApplicant ",
      window.getFriendReqListAsApplicant,
      [e]
    ));
    i(this, "getFriendList", (e = r()) => this._invoker(
      "getFriendList ",
      window.getFriendList,
      [e]
    ));
    i(this, "setFriendRemark", (e, n = r()) => this._invoker("setFriendRemark ", window.setFriendRemark, [
      n,
      JSON.stringify(e)
    ]));
    i(this, "checkFriend", (e, n = r()) => this._invoker("checkFriend", window.checkFriend, [
      n,
      JSON.stringify(e)
    ]));
    i(this, "acceptFriendReq", (e, n = r()) => this._invoker(
      "acceptFriendReq",
      window.acceptFriendReq,
      [n, JSON.stringify(e)]
    ));
    i(this, "refuseFriendReq", (e, n = r()) => this._invoker(
      "refuseFriendReq ",
      window.refuseFriendReq,
      [n, JSON.stringify(e)]
    ));
    i(this, "deleteFriend", (e, n = r()) => this._invoker("deleteFriend ", window.deleteFriend, [
      n,
      e
    ]));
    i(this, "addBlack", (e, n = r()) => this._invoker("addBlack ", window.addBlack, [n, e]));
    i(this, "removeBlack", (e, n = r()) => this._invoker("removeBlack ", window.removeBlack, [
      n,
      e
    ]));
    i(this, "getBlackList", (e = r()) => this._invoker(
      "getBlackList ",
      window.getBlackList,
      [e]
    ));
    i(this, "inviteUserToGrp", (e, n = r()) => this._invoker("inviteUserToGrp ", window.inviteUserToGrp, [
      n,
      e.groupID,
      e.reason,
      JSON.stringify(e.userIDList)
    ]));
    i(this, "kickGrpMember", (e, n = r()) => this._invoker("kickGrpMember ", window.kickGrpMember, [
      n,
      e.groupID,
      e.reason,
      JSON.stringify(e.userIDList)
    ]));
    i(this, "isJoinGrp", (e, n = r()) => this._invoker("isJoinGrp ", window.isJoinGrp, [
      n,
      e
    ]));
    i(this, "getSpecifiedGrpMembersInfo", (e, n = r()) => this._invoker(
      "getSpecifiedGrpMembersInfo ",
      window.getSpecifiedGrpMembersInfo,
      [n, e.groupID, JSON.stringify(e.userIDList)]
    ));
    i(this, "getGrpMemberListByJoinTimeFilter", (e, n = r()) => this._invoker(
      "getGrpMemberListByJoinTimeFilter ",
      window.getGrpMemberListByJoinTimeFilter,
      [
        n,
        e.groupID,
        e.offset,
        e.count,
        e.joinTimeBegin,
        e.joinTimeEnd,
        JSON.stringify(e.filterUserIDList)
      ]
    ));
    i(this, "searchGrpMembers", (e, n = r()) => this._invoker(
      "searchGrpMembers ",
      window.searchGrpMembers,
      [n, JSON.stringify(e)]
    ));
    i(this, "setGrpApplyMemberFriend", (e, n = r()) => this._invoker(
      "setGrpApplyMemberFriend ",
      window.setGrpApplyMemberFriend,
      [n, e.groupID, e.rule]
    ));
    i(this, "setGrpLookMemberInfo", (e, n = r()) => this._invoker(
      "setGrpLookMemberInfo ",
      window.setGrpLookMemberInfo,
      [n, e.groupID, e.rule]
    ));
    i(this, "getJoinedGrpList", (e = r()) => this._invoker(
      "getJoinedGrpList ",
      window.getJoinedGrpList,
      [e]
    ));
    i(this, "createGrp", (e, n = r()) => this._invoker("createGrp ", window.createGrp, [
      n,
      JSON.stringify(e)
    ]));
    i(this, "setGrpInfo", (e, n = r()) => this._invoker("setGrpInfo ", window.setGrpInfo, [
      n,
      JSON.stringify(e)
    ]));
    i(this, "setGrpMemberNickname", (e, n = r()) => this._invoker(
      "setGrpMemberNickname ",
      window.setGrpMemberNickname,
      [n, e.groupID, e.userID, e.groupMemberNickname]
    ));
    i(this, "setGrpMemberInfo", (e, n = r()) => this._invoker("setGrpMemberInfo ", window.setGrpMemberInfo, [
      n,
      JSON.stringify(e)
    ]));
    i(this, "joinGrp", (e, n = r()) => this._invoker("joinGrp ", window.joinGrp, [
      n,
      e.groupID,
      e.reqMsg,
      e.joinSource
    ]));
    i(this, "searchGrps", (e, n = r()) => this._invoker("searchGrps ", window.searchGrps, [
      n,
      JSON.stringify(e)
    ]));
    i(this, "quitGrp", (e, n = r()) => this._invoker("quitGrp ", window.quitGrp, [
      n,
      e
    ]));
    i(this, "dismissGrp", (e, n = r()) => this._invoker("dismissGrp ", window.dismissGrp, [
      n,
      e
    ]));
    i(this, "changeGrpMute", (e, n = r()) => this._invoker("changeGrpMute ", window.changeGrpMute, [
      n,
      e.groupID,
      e.isMute
    ]));
    i(this, "changeGrpMemberMute", (e, n = r()) => this._invoker(
      "changeGrpMemberMute ",
      window.changeGrpMemberMute,
      [n, e.groupID, e.userID, e.mutedSeconds]
    ));
    i(this, "transferGrpOwner", (e, n = r()) => this._invoker("transferGrpOwner ", window.transferGrpOwner, [
      n,
      e.groupID,
      e.newOwnerUserID
    ]));
    i(this, "getGrpReqListAsApplicant", (e = r()) => this._invoker(
      "getGrpReqListAsApplicant ",
      window.getGrpReqListAsApplicant,
      [e]
    ));
    i(this, "getGrpReqListAsRecipient", (e = r()) => this._invoker(
      "getGrpReqListAsRecipient ",
      window.getGrpReqListAsRecipient,
      [e]
    ));
    i(this, "acceptGrpReq", (e, n = r()) => this._invoker(
      "acceptGrpReq ",
      window.acceptGrpReq,
      [n, e.groupID, e.fromUserID, e.handleMsg]
    ));
    i(this, "refuseGrpReq", (e, n = r()) => this._invoker(
      "refuseGrpReq ",
      window.refuseGrpReq,
      [n, e.groupID, e.fromUserID, e.handleMsg]
    ));
    i(this, "resetConversationGrpAtType", (e, n = r()) => this._invoker(
      "resetConversationGrpAtType ",
      window.resetConversationGrpAtType,
      [n, e]
    ));
    i(this, "setGrpMemberRoleLevel", (e, n = r()) => this._invoker(
      "setGrpMemberRoleLevel ",
      window.setGrpMemberRoleLevel,
      [n, e.groupID, e.userID, e.roleLevel]
    ));
    i(this, "setGrpVerification", (e, n = r()) => this._invoker(
      "setGrpVerification ",
      window.setGrpVerification,
      [n, e.groupID, e.verification]
    ));
    i(this, "getGrpMemberOwnerAndAdmin", (e, n = r()) => this._invoker(
      "getGrpMemberOwnerAndAdmin ",
      window.getGrpMemberOwnerAndAdmin,
      [n, e]
    ));
    /*  setGlobalRecvMessageOpt = <T>(
       opt: MessageReceiveOptType,
       operationID = uuidv4()
     ) => {
       return this._invoker<T>(
         'setGlobalRecvMessageOpt ',
         window.setGlobalRecvMessageOpt,
         [operationID, opt]
       );
     }; */
    i(this, "findMsgList", (e, n = r()) => this._invoker(
      "findMsgList ",
      window.findMsgList,
      [n, JSON.stringify(e)]
    ));
    i(this, "uploadFile", (e, n = r()) => (e.uuid = `${e.uuid}/${e.file.name}`, p(e.uuid, e.file), this._invoker("uploadFile ", window.uploadFile, [
      n,
      JSON.stringify({
        ...e,
        filepath: "",
        cause: ""
      })
    ])));
    i(this, "subscribeUsersStatus", (e, n = r()) => this._invoker(
      "subscribeUsersStatus ",
      window.subscribeUsersStatus,
      [n, JSON.stringify(e)]
    ));
    i(this, "unsubscribeUsersStatus", (e, n = r()) => this._invoker(
      "unsubscribeUsersStatus ",
      window.unsubscribeUsersStatus,
      [n, JSON.stringify(e)]
    ));
    i(this, "getUserStatus", (e, n = r()) => this._invoker(
      "getUserStatus ",
      window.getUserStatus,
      [n, JSON.stringify(e)]
    ));
    i(this, "getSubscribeUsersStatus", (e = r()) => this._invoker(
      "getSubscribeUsersStatus ",
      window.getSubscribeUsersStatus,
      [e]
    ));
    i(this, "signalingInvite", (e, n = r()) => this._invoker("signalingInvite ", window.signalingInvite, [
      n,
      JSON.stringify(e)
    ]));
    /*   signalingInviteInGroup = <T>(
        data: SignalingInviteParams,
        operationID = uuidv4()
      ) => {
        return this._invoker<T>(
          'signalingInviteInGroup ',
          window.signalingInviteInGroup,
          [operationID, JSON.stringify(data)]
        );
      }; */
    i(this, "signalingAccept", (e, n = r()) => this._invoker("signalingAccept ", window.signalingAccept, [
      n,
      JSON.stringify(e)
    ]));
    i(this, "signalingReject", (e, n = r()) => this._invoker("signalingReject ", window.signalingReject, [
      n,
      JSON.stringify(e)
    ]));
    i(this, "signalingCancel", (e, n = r()) => this._invoker("signalingCancel ", window.signalingCancel, [
      n,
      JSON.stringify(e)
    ]));
    i(this, "signalingHungUp", (e, n = r()) => this._invoker("signalingHungUp ", window.signalingHungUp, [
      n,
      JSON.stringify(e)
    ]));
    /*   signalingGetRoomByGroupID = <T>(groupID: string, operationID = uuidv4()) => {
        return this._invoker<T>(
          'signalingGetRoomByGroupID ',
          window.signalingGetRoomByGroupID,
          [operationID, groupID]
        );
      }; */
    i(this, "signalingGetTokenByRoomID", (e, n = r()) => this._invoker(
      "signalingGetTokenByRoomID ",
      window.signalingGetTokenByRoomID,
      [n, e]
    ));
    i(this, "signalingSendCustomSignal", (e, n = r()) => this._invoker(
      "signalingSendCustomSignal ",
      window.signalingSendCustomSignal,
      [n, e.customInfo, e.roomID]
    ));
    i(this, "signalingCreateMeeting", (e, n = r()) => this._invoker(
      "signalingCreateMeeting ",
      window.signalingCreateMeeting,
      [n, JSON.stringify(e)]
    ));
    i(this, "signalingJoinMeeting", (e, n = r()) => this._invoker(
      "signalingJoinMeeting ",
      window.signalingJoinMeeting,
      [
        n,
        JSON.stringify({
          roomID: e
        })
      ]
    ));
    i(this, "signalingUpdateMeetingInfo", (e, n = r()) => this._invoker(
      "signalingUpdateMeetingInfo ",
      window.signalingUpdateMeetingInfo,
      [n, JSON.stringify(e)]
    ));
    i(this, "signalingCloseRoom", (e, n = r()) => this._invoker("signalingCloseRoom ", window.signalingCloseRoom, [
      n,
      e
    ]));
    i(this, "signalingGetMeetings", (e = r()) => this._invoker(
      "signalingGetMeetings ",
      window.signalingGetMeetings,
      [e]
    ));
    i(this, "signalingOperateStream", (e, n = r()) => this._invoker(
      "signalingOperateStream ",
      window.signalingOperateStream,
      [
        n,
        e.streamType,
        e.roomID,
        e.userID,
        e.mute,
        e.muteAll
      ]
    ));
    i(this, "setConversationIsMsgDestruct", (e, n = r()) => this._invoker(
      "setConversationIsMsgDestruct ",
      window.setConversationIsMsgDestruct,
      [n, e.conversationID, e.isMsgDestruct]
    ));
    i(this, "setConversationMsgDestructTime", (e, n = r()) => this._invoker(
      "setConversationMsgDestructTime ",
      window.setConversationMsgDestructTime,
      [n, e.conversationID, e.msgDestructTime]
    ));
    i(this, "fileMapSet", (e, n) => p(e, n));
    typeof e.assetsUrl == "string" && (e.assetsUrl = {
      sdkWasm: `${e.assetsUrl}CRIM.wasm`,
      sqlWasm: `${e.assetsUrl}sql-wasm.wasm`
    }), N(e.assetsUrl.sqlWasm), this.wasmInitializedPromise = x(e.assetsUrl.sdkWasm), this.goExitPromise = E(), this.goExitPromise && this.goExitPromise.then(() => {
      console.info("SDK => wasm exist");
    }).catch((n) => {
      console.info("SDK => wasm with error ", n);
    }).finally(() => {
      this.goExisted = !0;
    });
  }
  _logWrap(...e) {
    this.isLogStandardOutput && console.info(...e);
  }
  _invoker(e, n, s, a) {
    return new Promise(async (M, l) => {
      this._logWrap(
        `%cSDK =>%c [OperationID:${s[0]}] (invoked by js) run ${e} with args ${JSON.stringify(
          s
        )}`,
        "font-size:14px; background:#7CAEFF; border-radius:4px; padding-inline:4px;",
        ""
      );
      let v = {
        operationID: s[0],
        event: e.slice(0, 1).toUpperCase() + e.slice(1).toLowerCase()
      };
      try {
        if (!G() || G().exited || this.goExisted)
          throw "wasm exist already, fail to run";
        let u = await n(...s);
        if (a && (this._logWrap(
          `%cSDK =>%c [OperationID:${s[0]}] (invoked by js) run ${e} with response before processor ${JSON.stringify(
            u
          )}`,
          f("#FFDC19"),
          ""
        ), u = a(u)), this.tryParse)
          try {
            u = JSON.parse(u);
          } catch {
          }
        v.data = u, M(v);
      } catch (u) {
        this._logWrap(
          `%cSDK =>%c [OperationID:${s[0]}] (invoked by js) run ${e} with error ${JSON.stringify(
            u
          )}`,
          f("#EE4245"),
          ""
        ), v = {
          ...v,
          ...u
        }, l(v);
      }
    });
  }
  exportDB(e = r()) {
    return this._invoker("exportDB", window.exportDB, [e]);
  }
}
let S;
function V(o) {
  return typeof window > "u" ? {} : S || (S = new P(o), S);
}
export {
  V as getSDK
};
//# sourceMappingURL=index.js.map
